import { FunctionComponent } from 'react';
import {
  Card,
  Layout,
  SkeletonDisplayText,
  SkeletonPage,
} from '@shopify/polaris';
import styled from 'styled-components';

const Container = styled.div`
  margin-top: 1.25rem;
  padding-top: 1rem;
  min-height: 408px;

  .Polaris-SkeletonPage__Title {
    margin-top: 0.25rem;
  }
  .Polaris-SkeletonPage__Page {
    padding: 0 2rem;
  }
`;

const TableContentContainer = styled.div`
  display: flex;

  justify-content: space-between;
  width: 100%;

  .Polaris-SkeletonDisplayText__DisplayText {
    width: 160px;
  }

  @media (max-width: 992px) {
    .Polaris-SkeletonDisplayText__DisplayText {
      margin-right: 1rem;
    }
  }
`;

const SmallSkeletonDisplayText = styled.div`
  .Polaris-SkeletonDisplayText__DisplayText {
    width: 80px;
  }
`;

const TableSkeleton: FunctionComponent<{
  pageTitle?: string;
}> = (props) => {
  const { pageTitle } = props;

  return (
    <Card>
      <Container>
        <SkeletonPage title={pageTitle} fullWidth>
          <Layout>
            <Layout.Section>
              {[...Array(6)].map((_, i) => (
                <div key={i}>
                  <TableContentContainer>
                    <SmallSkeletonDisplayText>
                      <SkeletonDisplayText size="small" />
                    </SmallSkeletonDisplayText>
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                  </TableContentContainer>
                  {i !== 5 && <hr />}
                </div>
              ))}
            </Layout.Section>
          </Layout>
        </SkeletonPage>
      </Container>
    </Card>
  );
};

export default TableSkeleton;
